// Confirmação de DESATIVAÇÃO. Desativar não mexe no que já existe: assinaturas
// e seguros vinculados seguem com a regra; só os NOVOS deixam de poder usá-la.
import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import type { PaymentConfiguration } from "@/types/payment-configurations"

const prefix = "pages.paymentConfigurations"

interface DeactivatePaymentConfigurationDialogProps {
  /** `null` mantém o diálogo fechado. */
  pending: PaymentConfiguration | null
  onConfirm: (configuration: PaymentConfiguration) => void
  onClose: () => void
}

export const DeactivatePaymentConfigurationDialog = ({
  pending,
  onConfirm,
  onClose,
}: DeactivatePaymentConfigurationDialogProps) => {
  const { t } = useTranslation()
  const name = pending?.description || pending?.id || ""

  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`${prefix}.deactivate.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(`${prefix}.deactivate.description`, {
              name,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
          <li>{t(`${prefix}.deactivate.keepsLinked`)}</li>
          <li>{t(`${prefix}.deactivate.blocksNew`)}</li>
          <li>{t(`${prefix}.deactivate.reversible`)}</li>
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t(`${prefix}.deactivate.cancel`)}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              if (pending) onConfirm(pending)
            }}
          >
            {t(`${prefix}.deactivate.confirm`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
